var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPartnersLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 119,
    viewBox: "0 0 203 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.332 0.0417557C115.782 0.0417557 92.5971 18.8612 86.0006 44.2771L79.4041 37.6806L58.0625 59.0222L101.328 101.22C112.096 111.988 126.938 118.682 143.332 118.682C176.12 118.682 202.603 92.1016 202.603 59.4102C202.603 26.6217 176.023 0.0417557 143.332 0.0417557Z",
    fill: "#3D82F1",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.304 59.701L135.185 68.8196C128.492 75.5131 117.53 75.5131 110.836 68.8196L79.6001 37.6803L101.233 17.4058L144.304 59.701Z",
    fill: "#3D82F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4176 56.4996L111.223 69.3046C112.484 64.4542 118.595 64.6482 118.595 59.3128C118.595 25.1662 89.7839 -2.18981 55.0553 0.138364C25.8561 2.17552 2.08937 25.8453 0.149224 55.0445C-2.27596 89.6761 25.1771 118.584 59.3237 118.584C68.8304 118.584 77.755 116.353 85.7096 112.376L45.1606 72.2148L58.2566 59.0218L60.6818 56.5966C71.1585 46.1198 88.0378 46.1198 98.4176 56.4996Z",
    fill: "#3D82F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.998 40.6874C122.573 42.7245 121.021 45.7318 121.021 49.127C120.924 55.2385 125.871 60.2829 131.983 60.3799C135.475 60.3799 138.676 58.8278 140.713 56.3056L124.998 40.6874Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9803 77.7444C79.4055 75.7072 80.8606 72.7 80.8606 69.3048C80.8606 63.1933 75.9132 58.1489 69.7048 58.1489C66.2125 58.1489 63.0113 59.798 60.9741 62.3202L76.9803 77.7444Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersLogo);
export default __webpack_public_path__ + "static/media/PartnersLogo.fdc385efe0291ee16ded9ee64d8c545d.svg";
export { ForwardRef as ReactComponent };